import type { KeyAndParams } from '@jiotranslate/core-beta';
import type { ElementMeta, NodeMeta, JioTranslateElement } from '../../types';

export function initElementMeta(element: JioTranslateElement): ElementMeta {
  return {
    element,
    nodes: new Map(),
  };
}

export function initNodeMeta(
  oldTextContent: string,
  keys: KeyAndParams[]
): NodeMeta {
  return {
    oldTextContent,
    keys,
  };
}
